/* eslint-disable no-useless-escape */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';
import CreditCardInput from 'react-credit-card-input';
import InputMask from 'react-input-mask';
import moment from 'moment-timezone';

import RegexCards from '../../../app/utils/cards';

import StringHelper from '../../../helpers/string';
import ValidatorsHelper from '../../../helpers/validators';
import CARDS from '../../../data/cards';
import inputSize from '../../../data/inputs';

class PaymentComponentCardNew extends React.PureComponent {
  constructor(props) {
    super(props);

    this.yearYY = new Date().getFullYear().toString().substr(-2);
    this.yearFirstTwo = new Date().getFullYear().toString().substr(0, 2);

    this.state = {
      installments: 1,
      securityCode: '',
      number: '',
      name: '',
      expirationDate: '',
      brand: '',
      brandErr: false,
      saveCard: false,
      cnpjError: '',
      cnpj: '',
      phone: '',
      birthDate: '',
    };

    if (props.values) {
      this.state.installments = props.values.installments;
      this.state.securityCode = props.values.securityCode;
      this.state.number = props.values.number;
      this.state.name = props.values.name;
      this.state.expirationDate = props.values.expirationDate;
      this.state.brand = props.values.brand;
    }

    this.initialState = { ...this.state };
  }

  componentDidMount = () => {
    if (this.props.paymentService === 'pagseguro') {
      this.checkPersonalData();
    }
  }

  setValue = async (key, value) => {
    if (key === 'birthDate') {
      if (!moment(value).isAfter(moment(new Date()).format('YYYY-MM-DD'))) {
        this.setState({
          birthDateError: false,
          [key]: value,
        });
      } else {
        this.setState({
          [`${key}Error`]: true,
          [key]: value,
        });
      }
    } else {
      this.setState({
        [`${key}Error`]: '',
        [`${key}Changed`]: true,
        [key]: value,
      });
    }
  }

  clearForm = () => this.setState({ ...this.initialState });

  formatCpnjCpf = (value, opcoRegisterCPF) => {
    if (opcoRegisterCPF && value.length <= 11) {
      return value.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, '\$1.\$2.\$3\-\$4');
    }

    return value.substring(0, 14).replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g, '\$1.\$2.\$3\/\$4\-\$5');
  }

  removeMarkCnpjCpf = value => value.replace(/(\.|\/|\-)/g, '');

  onBlurCnpj = () => {
    const { cnpj } = this.state;
    const type = cnpj.length <= 11 ? 'cpf' : 'cnpj';
    const value = cnpj;

    if (!value.trim()) return;

    if (type === 'cnpj' && !ValidatorsHelper.validarCNPJ(value)) {
      this.setState({ cnpjError: I18n.t('invalidCNPJ') });
      this.props.setDocument({ value: '', type: '' });
      return;
    }
    if (type === 'cpf' && !ValidatorsHelper.validarCPF(value)) {
      this.setState({ cnpjError: I18n.t('invalidCPF') });
      this.props.setDocument({ value: '', type: '' });
      return;
    }

    this.props.setDocument({ value, type });
  }

  numberOfInstallments = (total) => {
    const installmentsTotal = [];
    for (let i = 1; i <= total; i += 1) installmentsTotal.push(i);
    return installmentsTotal.map(p => <option key={p} value={p}>{`${p} x`}</option>);
  }

  handleCardNumberChange = (e) => {
    const { brandsAllowed } = this.props;
    const { value } = e.target;
    const brand = RegexCards.getCardsName(StringHelper.keepOnlyNumber(value));

    let brandErr = false;
    if (brand !== CARDS.name.invalid && brandsAllowed.indexOf(brand) === -1) brandErr = true;

    this.setState({ number: value, brand, brandErr });
  }

  handleCardExpirationDateChange = (e) => {
    this.setState({ expirationDate: e.target.value });
  }

  handleCardCVVChange = (e) => {
    this.setState({ securityCode: e.target.value });
  }

  isValid = () => {
    const {
      securityCode, number, name, expirationDate, brand, brandErr, birthDateError,
      birthDate,
    } = this.state;
    const { document } = this.props;

    if (this.props.paymentService === 'pagseguro') {
      if (brandErr || brand === CARDS.name.invalid) return;
      if (birthDateError || birthDateError === undefined || birthDate === '') return;

      if (!ValidatorsHelper.validDocument(document.type, document.value)) return;

      if (StringHelper.keepOnlyNumber(securityCode).length < 3
        || StringHelper.keepOnlyNumber(securityCode).length > 4) return;

      if (!number || !name || !expirationDate) return;
      return true;
    }
    if (brandErr || brand === CARDS.name.invalid) return;

    if (!ValidatorsHelper.validDocument(document.type, document.value)) return;

    if (StringHelper.keepOnlyNumber(securityCode).length < 3
      || StringHelper.keepOnlyNumber(securityCode).length > 4) return;

    if (!number || !name || !expirationDate) return;
    return true;
  }

  setPayment = () => {
    const {
      securityCode, number, name, expirationDate, brand, installments, saveCard,
    } = this.state;
    const { type, document } = this.props;

    const brandErr = RegexCards.getCardsName(StringHelper.keepOnlyNumber(number));
    if (brandErr === 'invalid') {
      this.setState({ message: I18n.t('cardInvalid') });
      return;
    }
    this.props.setPayment(type, {
      card: {
        securityCode,
        number: StringHelper.keepOnlyNumber(number),
        name,
        expirationDate: expirationDate.split('/').join(`/${this.yearFirstTwo}`),
        document,
        brand,
        installments,
        saveCard,
      },
      document,
    }, saveCard);
  }

  beforeMaskedStateChange = (nextState) => {
    let { value } = nextState;

    if (value) {
      const splittedValue = value.split('/');
      const firstValue = splittedValue[0].replace(/[_]/g, '').trim();
      const secondValue = splittedValue[1].replace(/[_]/g, '').trim();

      if (firstValue) {
        const newFirstValue = Number(firstValue);

        if (newFirstValue > 12) {
          value = `${12}/${secondValue}`;
        } else if (firstValue === '00') {
          value = `01/${secondValue}`;
        }
      }

      if (secondValue && secondValue.length === 2) {
        const newSecondValue = Number(secondValue);

        if (newSecondValue && newSecondValue < this.yearYY) {
          value = `${value.split('/')[0]}/${this.yearYY}`;
        } else if (!newSecondValue) {
          value = `${value.split('/')[0]}/__`;
        }
      }
    }

    return {
      ...nextState,
      value,
    };
  }

  checkData = async () => {
    if (this.props.paymentService === 'pagseguro') {
      if (this.state.phone.length > 13) {
        this.props.setData({ phone: this.state.phone, birthDate: this.state.birthDate });
        this.setPayment(this.state);
      } else {
        await this.setState({
          phoneError: I18n.t('incompletePhoneError'),
        });
      }
    } else {
      this.setPayment(this.state);
    }
  }

  checkPersonalData = () => {
    if (this.props.personalData && this.props.personalData.birthDate && !this.state.birthDate) {
      this.setValue('birthDate', this.props.personalData.birthDate);
    }
    if (this.props.personalData && this.props.personalData.phone && !this.state.phone) {
      this.setValue('phone', this.props.personalData.phone);
    }
  }

  render() {
    const {
      number, name, securityCode, expirationDate, brandErr,
      phone, birthDate, phoneError, birthDateError,
      cnpj, cnpjError,
    } = this.state;
    const {
      type, installmentsTotal,
    } = this.props;

    return (
      <React.Fragment>
        <span className="line" />

        <div className="basket-card">
          <div className="add-card cursorPointer">{I18n.t('addCard')}</div>

          <div className="basket-form">
            <div className="basket-form__group">
              <label className="lbl">
                {I18n.t('cardName')}
                <input
                  className="fld"
                  type="text"
                  value={name}
                  maxLength={inputSize.max}
                  onChange={e => this.setState({ name: e.target.value })}
                  required
                />
              </label>
            </div>
            <div className="basket-form__group">
              <label className="lbl">
                {I18n.t('cardNumber')}
                <CreditCardInput
                  cardNumberInputProps={{ value: number, onChange: this.handleCardNumberChange }}
                  cardExpiryInputRenderer={({ props }) => (
                    <div ref={props.ref} />
                  )}
                  cardCVCInputRenderer={() => null}
                  containerStyle={{ display: 'unset' }}
                  fieldStyle={{
                    width: '100%',
                    border: '1px solid #D9D9D9',
                    backgroundColor: '#FFF',
                    MozBorderRadius: '6px',
                    borderRadius: '6px',
                    margin: '4px 0 0',
                    padding: '0 10px',
                    height: '42px',
                  }}
                  customTextLabels={{
                    invalidCardNumber: I18n.t('cardNumberInvalid'),
                    cardNumberPlaceholder: ' ',
                  }}
                />
              </label>
              {brandErr && (<p className="error-msg">{I18n.t('flagInvalid')}</p>)}
            </div>
            <div className="basket-form__group">
              <label className="lbl">
                {I18n.t('loginNewRegisterCnpjCpf')}
                <input
                  className="fld"
                  type="text"
                  value={this.formatCpnjCpf(cnpj, true)}
                  onChange={e => this.setValue('cnpj', this.removeMarkCnpjCpf(e.target.value))}
                  onBlur={this.onBlurCnpj}
                  required
                />
              </label>
              {cnpjError ? <p className="error-msg">{cnpjError}</p> : ''}
            </div>
            <div className="basket-form__group g-30">
              <label className="lbl">
                {I18n.t('securityCode2')}
                <InputMask
                  mask={RegexCards.getMaskCard(RegexCards.getCardsName(number))}
                  value={securityCode}
                  onChange={this.handleCardCVVChange}
                >
                  {inputProps => (
                    <input
                      {...inputProps}
                      className="fld"
                      type="text"
                      placeholder={I18n.t('cvv')}
                      required
                    />
                  )}
                </InputMask>
              </label>
            </div>
            <div className="basket-form__group g-30">
              <label className="lbl">
                {I18n.t('expirationPlaceholder')}
                <InputMask
                  value={expirationDate}
                  beforeMaskedValueChange={this.beforeMaskedStateChange}
                  mask="99/99"
                  onChange={this.handleCardExpirationDateChange}
                >
                  {inputProps => (
                    <input
                      {...inputProps}
                      className="fld"
                      type="text"
                      placeholder={I18n.t('expirationPlaceholder')}
                      required
                    />
                  )}
                </InputMask>
              </label>
            </div>
            {type === 'credit' && (
              <div className="basket-form__group g-30">
                <label className="lbl">
                  {I18n.t('installments')}
                  <div className="select select--white">
                    <select
                      defaultValue="num"
                      onChange={e => this.setState({ installments: Number(e.target.value) })}
                    >
                      {this.numberOfInstallments(installmentsTotal)}
                    </select>
                  </div>
                </label>
              </div>
            )}
            {(this.props.paymentService === 'pagseguro')
              ? (
                <div>
                  <div className="basket-form__group">
                    <label className="lbl">
                      {I18n.t('phone2')}
                      <InputMask
                        tabIndex="-1"
                        className="fld"
                        type="text"
                        mask={phone.length > 14 ? '(99) 9 9999-9999' : '(99) 9999-99999'}
                        maskChar={null}
                        value={phone}
                        onChange={e => this.setValue('phone', e.target.value)}
                        required
                      />
                    </label>
                    {phoneError ? (
                      <div style={{ height: 50 }}>
                        <p className="error-msg">{phoneError}</p>
                      </div>
                    ) : ''}
                  </div>
                  <div className="basket-form__group">
                    <label className="lbl">
                      {I18n.t('birthDate2')}
                      <input
                        tabIndex="-1"
                        className="fld"
                        type="date"
                        value={birthDate}
                        onChange={e => this.setValue('birthDate', e.target.value)}
                        required
                      />
                    </label>
                    {birthDateError ? (
                      <div style={{ height: 50 }}>
                        <p className="error-msg">{I18n.t('errorDateReported')}</p>
                      </div>
                    ) : ''}
                  </div>
                </div>
              )
              : ''
            }
            <div className="basket-form__btns">
              <button type="button" className="btn" onClick={() => this.clearForm()}>{I18n.t('clear')}</button>
              <button
                type="button"
                className="btn"
                onClick={() => this.checkData()}
                disabled={!this.isValid()}
              >
                {I18n.t('confirm')}
              </button>
            </div>
            <div className="basket-form__group">
              <label className="lbl">
                <input
                  className="ckb"
                  type="checkbox"
                  value={this.state.saveCard}
                  onChange={e => this.setState({ saveCard: e.target.checked })}
                />
                &nbsp;
                {I18n.t('saveCardText')}
              </label>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  brandsAllowed: state.settings.paymentMethods[ownProps.type],
  documentType: state.settings.documentType,
});

export default connect(mapStateToProps)(PaymentComponentCardNew);
